export const setMandateDetails = data => ({
  type: 'SET_MANDATE_DETAILS',
  data,
  loader: false,
});

export const generateMandateOTP = payload => ({
  type: 'GENERATE_MANDATE_OTP',
  payload,
  loader: true,
});

export const setMandateReferenceId = data => ({
  type: 'SET_MANDATE_REFERENCE_ID',
  data,
  loader: false,
});

export const createMandate = payload => ({
  type: 'CREATE_MANDATE',
  payload,
  loader: true,
});

export const updateMandate = payload => ({
  type: 'UPDATE_MANDATE',
  payload,
  loader: true,
});

export const deleteMandate = payload => ({
  type: 'DELETE_MANDATE',
  payload,
  loader: true,
});

export const setMandateSuccess = data => ({
  type: 'SET_MANDATE_SUCCESS',
  data,
  loader: false,
});

export const resetMandateDetails = () => ({
  type: 'RESET_MANDATE_DETAILS',
});
